import decodeCookieJwt from '@sls-react/utils/decodeCookieJwt';
import { NextPageContext } from 'next';

export default function getUuid(context?: NextPageContext) {
  const jwt = decodeCookieJwt(context);

  if (jwt) {
    return jwt.uuid;
  }

  return null;
}
